<div class="flex flex-row items-center justify-center gap-3 w-full py-10" (mouseleave)="hovered = 0">
  <i *ngFor="let star of stars"
    class="btn fa-star text-4xl md:text-5xl transition-all duration-150 ease-expo"
    [ngClass]="star <= activeCount ? 'fa-solid text-exp' : 'fa-light text-zen text-opacity-30'"
    (mouseenter)="hovered = star"
    (click)="setRating(star)"></i>
</div>
